<template lang="pug">
.application
  component(:is='headerCom.component',:key="headerCom.id" :type="type" :actionData="headerCom" @openOther="openOther" @closeCom="closeCom" v-if="headerCom")
  .left(v-show="showApp && leftList.length")
    .operButton(
      v-for="item,index in leftList",
      :title='item.cnName',
      :key="index",
      @click.stop='openFun(item,index)')
      .fileName(v-if="type=='modelDwg'") {{modelPageFileName}}
      van-image(:class="{'aim' : type=='model'}" width='25' height='25' :src='item.icon1')
  .right(:class="downStyle" v-show="rightList.length")
    .operButton(
      v-for="item,index in rightList",
      :title='item.cnName',
      :key="index",
      @click.stop='openFun(item,index)')
      van-image(width='25' height='25' :src='item.icon1' v-if='item.actived')
      van-image(width='25' height='25' :src='item.icon0' v-else)
  .down(:class="downStyle" v-show="operList.length")
    .operButton(
      v-for="item,index in operList",
      :title='item.cnName',
      :key="index",
      @click.stop='openFun(item,index)')
      van-image(width='25' height='25' :src='item.icon1' v-if='item.actived')
      van-image(width='25' height='25' :src='item.icon0' v-else)
  //- 组件展示
  component(:is='app.component',v-for="app in activeApplication",:key="app.id" :type="type" :actionData="app" @openOther="openOther" @closeCom="closeCom")
</template>

<script>
import { getMapList, getModelMapList, getModelList, getOtherList } from "./applicationH5";
import { mongeApp } from "@/CommonDP/mongeView/store/mongeStore";
import { getToken } from "@/CommonDP/mongeView/utils";

export default {
  props: {
    type: {
      type: String,
      default: "dwg"
    }
  },
  data () {
    let showAllList = []; let downStyle; let appList;
    const { noNeedIssue, shareSource } = this.$route.query;
    switch (this.type) {
      case "dwg":
        appList = getMapList();
        downStyle = "dwgStyle";
        break;
      case "model":
        appList = getModelList();
        downStyle = "modelStyle";
        break;
      case "modelDwg":
        appList = getModelMapList();
        downStyle = "modelMapStyle";
        break;
      default:
        appList = getOtherList();
        downStyle = "otherStyle";
        break;
    }
    if (!getToken() || noNeedIssue === "true" || shareSource === 1 || shareSource === 2) {
      showAllList = appList.filter(({ id }) => id !== "issue" && id !== "list" && id !== "notation");
    } else {
      showAllList = appList;
    }
    return { showAllList, downStyle };
  },
  computed: {
    showApp() {
      return mongeApp.showApp;
    },
    // 展示应用组件
    activeApplication() {
      return this.showAllList.filter(({ actived, component }) => actived && component);
    },
    // 底部应用按钮组件
    operList() {
      // 整合模型没有的应用（版本比对）
      if (this.type === 'model' && this.modelInfoData?.fileObj) {
        return this.showAllList.filter(({ button, id }) => button === "bottom" && id !== "comparison");
      } else {
        return this.showAllList.filter(({ button }) => button === "bottom");
      }
    },
    headerCom() {
      return this.showAllList.find(({ button }) => button === "header");
    },
    rightList() {
      return this.showAllList.filter(({ button }) => button === "right");
    },
    leftList() {
      return this.showAllList.filter(({ button }) => button === "left");
    },
    modelPageFileName() {
      return mongeApp.model.modelPageFileName;
    },
    fileType() {
      return this.$route.query.fileType;
    }
  },
  methods: {
    // 打开对应组件-点击高亮按钮时关闭组件
    async openFun(item) {
      if (item.id === "reset") {
        item.open();
        return;
      }
      this.showAllList.forEach(async ele => {
        if (ele.id === item.id && !ele.actived) {
          ele.open(null, this.fileType);
        } else {
          ele.close();
        }
      });
    },
    // 按钮组件触发其他按钮的应用
    openOther(data) {
      this.showAllList.forEach(e => {
        if (e.id === data)e.open(null, this.fileType);
        else e.close();
      });
    },
    // 关闭组件 ：boolean为true时关闭组件,false为最小化
    closeCom(id) {
      this.showAllList.forEach(async ele => {
        if (ele.id === id) {
          ele.close();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.left{
  position: absolute;
  top: 46px;
  left: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 4;
  .operButton{
    display: flex;
    flex-direction: row;
    align-items: center;
    .van-image{
      margin-left: 5px;
    }
    .aim{
      margin-top: 10px;
    }
    .fileName{
      width: 220px;
      height: 40px;
      color: #fff;
      line-height: 40px;
      font-size: 14px;
      font-weight: 400;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      text-indent: 10px;
      background: hsla(0,0%,100%,.12);
      border-radius: 0 0 10px 0;
    }
  }
}
.right{
  position: absolute;
  top: 46px;
  right: 0;
  width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 4;
  .operButton{
    width: 40px;
    height: 40px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(26, 36, 48, 0.9);
    border-radius: 0px 0px 0px 15px;
  }
}
.right.modelStyle{
  position: absolute;
  top: 54px;
  right: 10px;
  width: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 4;
  .operButton{
    background: hsla(0,0%,100%,.85);
    border-radius: 7px;
  }
}
.right.modelMapStyle{
  top: 46px;
}
.down{
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  background: rgba(0, 0, 0, 0.68);
  width: 100%;
  height: 48px;
  z-index: 4;
  bottom: 0;
}
.down.modelStyle{
  background: hsla(0,0%,100%,.88);
  border-radius: 15px;
  position: absolute;
  width: calc(100% - 20px);
  height: 48px;
  left: 10px;
  bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around
}
.down.otherStyle{
  background: rgba(255, 255, 255, 0.92);
}
</style>
